@if (forms) {
  <div class="astral-stack-l">
    @if (rooms.length) {
      <div class="astral-stack-s">
        @for (room of rooms; track room) {
          <app-room-form
            [forms]="forms"
            [rootForm]="rootForm"
            [componentCategories]="componentCategories"
            [room]="room"
            [rentalObject]="rentalObject"
            (componentAdded)="addedComponent()"
          ></app-room-form>
        }
      </div>
    }
    <div class="astral-form-actions astral-form-actions--start">
      <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ROOM.ADD_ROOM" (click)="addRoom()"></astral-button>
      <astral-button variant="secondary" size="small" type="button" labelKey="ROOM.REORDER_ROOMS" (click)="reorderRoomsSidebarOpen()"></astral-button>
    </div>
  </div>
}

<app-room-order-sidebar
  [items]="rooms"
  [open]="roomsOrderSidebarOpen"
  (onSave)="reorderRoomsAccept($event)"
  (onCancel)="reorderRoomsSidebarClose($event)">
</app-room-order-sidebar>
